





































import {Vue, Component, Prop, Watch, Ref} from 'vue-property-decorator'
import {SelectWings} from "@/components";

@Component({components: {SelectWings}})
export default class TemplateInputWings extends Vue {
  @Prop(String) readonly label: string | undefined;
  @Prop({default: true}) readonly show_counter: boolean | undefined;
  @Prop({default: undefined}) readonly applicationId: number | undefined;
  @Prop({default: []}) readonly optionList: string | undefined;
  @Prop(String) value!: string;
  @Ref('container') container: any;

  private valueSelf = this.value;
  private original: string | null = null
  private personalisation: string | null = null;
  private resetting = false;
  private templateField: any = undefined

  get count(): number {
    if (!this.valueSelf) return 0;
    return this.valueSelf.length
  }

  get isTextUnicode(): boolean {
    let text = this.valueSelf;
    for (let charPos = 0; charPos < text.length; charPos++) {
      if (text.charCodeAt(charPos) > 127) {
        return true;
      }
    }
    return false;
  };

  onClickHandle() {
    if (this.isTextUnicode) {
        this.original = this.valueSelf
        this.valueSelf = this.transliterate(this.valueSelf)
    } else if (this.original) {
        this.valueSelf = this.original
    }
  }

  transliterate(text: string, engToRus: boolean = false) {
    let rus = "щ   ш  ч  ц  ю  я  ё  ж  ъ  ы  э  а б в г д е з и й к л м н о п р с т у ф х ь".split(/ +/g);
    let eng = "shh sh ch cz yu ya yo zh `` y' e` a b v g d e z i j k l m n o p r s t u f x `".split(/ +/g);
    let x;
    for (x = 0; x < rus.length; x++) {
      text = text.split(engToRus ? eng[x] : rus[x]).join(engToRus ? rus[x] : eng[x]);
      text = text.split(engToRus ? eng[x].toUpperCase() : rus[x].toUpperCase()).join(engToRus ? rus[x].toUpperCase() : eng[x].toUpperCase());
    }
    return text;
  }

  mounted() {
    this.templateField = this.$refs.container
    this.templateField = this.templateField.querySelector('textarea, input[type="text"]')
  }

  addPersonalisation($event: string) {
    if (!$event) return;
    this.$emit('change', $event)
    const startPos = this.templateField.selectionStart
    const endPos = this.templateField.selectionEnd
    if (this.templateField.selectionStart || this.templateField.selectionStart === 0) {
      this.valueSelf = this.valueSelf.substring(0, startPos) + $event + this.valueSelf.substring(endPos, this.valueSelf.length)
    } else {
      this.valueSelf += $event;
    }
    this.resetPersonalisationSelect();
  }

  resetPersonalisationSelect(): void {
    this.personalisation = null;
    this.resetting = true;
    setTimeout(() => {
      this.resetting = false
    }, 1)
  }

  @Watch('value')
  getValue(val: string) {
    this.valueSelf = val
  }

  @Watch('valueSelf')
  sendValue(val: string) {
    this.$emit('input', val)
  }

}
